import { render, staticRenderFns } from "./Datenimport.vue?vue&type=template&id=ff3511d6&scoped=true&"
import script from "./Datenimport.vue?vue&type=script&lang=js&"
export * from "./Datenimport.vue?vue&type=script&lang=js&"
import style0 from "./Datenimport.vue?vue&type=style&index=0&id=ff3511d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3511d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VRow,VSnackbar})
